import { atom } from 'jotai';
import { ClientOnboardingForm, ClientType } from '../api';
import { MpmSection } from '../types/MpmTypes';
import { isMpmEnabled } from '../utils/features';

export type FormState = ClientOnboardingForm & { mpmSection: MpmSection };

export const DefaultClientOnboardingForm: FormState = {
    // ModernPM is only pre-selected when MPM creation is enabled (VITE_ENABLE_MPM).
    systems: isMpmEnabled() ? ['CCH', 'MPM'] : ['CCH'],
    mpmSection: { projects: [] },
    clientType: ClientType.Individual,
    // subClientType: "",
    generalSection: {
        businessUnitId: '',
        officeId: '',
        businessSection: {
            businessName: '',
            businessCode: '',
            dateIncorporated: undefined,
            principalBusinessActivity: '',
            principalProductService: '',
        },
        individualSection: {
            firstName: '',
            middleName: undefined,
            lastName: '',
            spouseFirstName: '',
            spouseMiddleName: undefined,
            spouseLastName: '',
        },
    },
    contactSection: {
        mailingAddress: {
            streetLine: '',
            streetLine2: undefined,
            city: '',
            state: '',
            zip: '',
        },
        mainAddress: {
            streetLine: '',
            streetLine2: '',
            city: '',
            state: '',
            zip: '',
        },
        mainEmail: '',
        mainPhone: '',
        mobilePhone: '',
    },
    adminSection: {
        yearEnd: '12/31',
        lineOfBusinessId: '',
        primaryPartnerId: '',
        billerId: '',
        rainmakerId: '',
        businessCode: '',
    },
};

export const ClientOnboardingFormAtom = atom<FormState>(DefaultClientOnboardingForm);
